var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.875,
    height: 53.875,
    viewBox: "0 0 53.875 53.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17062",
    "data-name": "Group 17062",
    transform: "translate(-555.06 -1912.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M24.11,6.8a4.967,4.967,0,0,1,9.654,0A4.968,4.968,0,0,0,41.18,9.868a4.97,4.97,0,0,1,6.83,6.83,4.968,4.968,0,0,0,3.069,7.412,4.967,4.967,0,0,1,0,9.654,4.968,4.968,0,0,0-3.072,7.415,4.97,4.97,0,0,1-6.83,6.83,4.968,4.968,0,0,0-7.412,3.069,4.967,4.967,0,0,1-9.654,0,4.968,4.968,0,0,0-7.415-3.072,4.97,4.97,0,0,1-6.83-6.83A4.968,4.968,0,0,0,6.8,33.764a4.967,4.967,0,0,1,0-9.654,4.968,4.968,0,0,0,3.072-7.415,4.97,4.97,0,0,1,6.83-6.83A4.967,4.967,0,0,0,24.11,6.8Z",
    transform: "translate(553.06 1910.646)",
    fill: "none",
    stroke: "#7e84a3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(574.414 1932)",
    fill: "none",
    stroke: "#7e84a3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/Cog.7d5cf97dcb61b6c94aaa767714e89b05.svg";
export { ForwardRef as ReactComponent };